module.exports = __webpack_public_path__ + "img/aseguradora.f40bdc03.gif";